module.exports = __webpack_public_path__ + "img/NoBad.8f6c6b04.png";